import axios from "../../config/interceptor";

export const postAssessment = async (data) => {
  try {
    const response = await axios.post(
      "/lambda/v1/assessment-progress-notes",
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getAssessment = async (visit_id, patient_id) => {
  try {
    let link = `/lambda/v1/assessment-progress-notes?visit_id=${visit_id}`;
    if (patient_id) {
      link += `&patient_id=${patient_id}`;
    }
    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const postVitalSigns = async (data) => {
  try {
    const response = await axios.post(
      "/lambda/v1/vital-sign",
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getVitalSigns = async (visit_id, patient_id) => {
  try {
    let link = `/lambda/v1/vital-sign?visit_id=${visit_id}`;
    if (patient_id) {
      link += `&patient_id=${patient_id}`;
    }
    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};
